export default "__VITE_ASSET__DdnPnFXR__"